import React from "react";
import ListItem from "../../StandardBoards/StandardBoardsList/ListItem";
import List from "../../../../components/List/List";
import styles from "./IoBoardsList.module.scss";
import { connect } from "react-redux";
import { parseEnumStart } from "../../../../utils/utils";
import IoBoardListItem from "./IoBoardListItem";
import arrowDown from "../../../../images/chevron-down.svg";
import arrowUp from "../../../../images/chevron-up.svg";
type StateProps = {
  ioConfig: State.IoConfig;
  sides: Api.BaseEnumeration[] | undefined;
};

type IoBoardsListProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rows: any[];
  onNodeSelect: (item: Api.AnyItem) => void;
  onRevisionClick: (item: Api.AnyItem) => void;
  onNodeEditClick?: (item: Api.AnyItem) => void;
  onBoardTypeClick: (item: Api.AnyItem) => void;
  onBoardEditClick: (item: Api.AnyItem) => void;
};

const IoBoardsList = (props: IoBoardsListProps & StateProps) => {
  const {
    rows,
    onNodeSelect,
    onRevisionClick,
    onBoardTypeClick,
    ioConfig,
    sides,
    onBoardEditClick
  } = props;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const boardTypes = Object.keys(rows).map((key: any) => {
    const boardType = rows[key];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let revisions: any;
    if (ioConfig.openedRows.ioBoardTypes.includes(key)) {
      revisions = Object.keys(boardType)
      .sort( (a, b) => a > b ? 1 : -1 )       
      .map((revisionName: string) => {
        const revisionId = boardType[revisionName][0].standard.id;
        let boardsList;
        if (ioConfig.openedRows.ioRevisions.includes(revisionId)) {
          boardsList = boardType[revisionName].map((ioBoard: Api.IoBoard) => {
            const nodes = ioBoard.ionodes;
            return (
              <div key={ioBoard.id}>
                <IoBoardListItem
                  title={
                    "Index " +
                    ioBoard.index +
                    " - Side " +
                    sides.find(s => s.enumValue === ioBoard.side)?.enumName + " [" + sides.find(s => s.enumValue === ioBoard.side)?.enumValue + "]"
                  }
                  nodes={nodes}
                  // Commented and saved on purpose,  Will be re-added later
                  onRowItemClick={onNodeSelect}
                  selectedNodeId={ioConfig.selectedIoBoard.ioNodeId}
                  onBoardEditClick={() => onBoardEditClick(ioBoard.id)}
                />
              </div>
            );
          });
        }
        return (
          <div key={revisionName} className={styles.RevisionItemWrapper}>
            <li id={revisionName} className={styles.showOnHove}>
              <div className={styles.ListItemDiv} onClick={() => onRevisionClick(revisionId)}>
                <div>
                  <span>{"Revision " + revisionName || "NA"}</span>
                </div>
                {ioConfig.openedRows.ioRevisions.includes(revisionId) !== undefined && (
                  <img
                    alt="arrow"
                    style={{ width: "15px" }}
                    src={ioConfig.openedRows.ioRevisions.includes(revisionId) ? arrowUp : arrowDown}
                  />
                )}
              </div>
              {boardsList && (
                <div className={styles.IoBoardsListWrapper}>
                  <List> {boardsList}</List>
                </div>
              )}
            </li>
          </div>
        );
      });
    }

    return (
      <div key={key} className={styles.BoardTypeItemWrapper}>
        <ListItem
          styleClass={styles.showOnHover}
          id={key}
          key={key}
          title={parseEnumStart(key, 2)}
          onRowItemClick={() => onBoardTypeClick(key)}
          opened={ioConfig.openedRows.ioBoardTypes.includes(key)}
        />
        {revisions && (
          <div className={styles.RevisionListWrapper}>
            <List> {revisions}</List>
          </div>
        )}
      </div>
    );
  });

  return (
    <div className={styles.BoardTypeWrapper}>
      <List>{boardTypes.sort((a, b) =>
      (a.key as string) > (b.key as string) ? 1 : -1
    )}</List>
    </div>
  );
};

const mapStateToProps = (state: State.Root) => ({
  ioConfig: state.ioConfig,
  sides: state.pdApi?.sides
});

export default connect(mapStateToProps)(IoBoardsList);
